import csv from "csvtojson";

export default class Locations {
  public static async getCitiesForDistrictFromCSV(
    csvString: string,
    districtName: string,
    isValueSameAsLabel: boolean = false
  ) {
    var cities: { value: any; label: any }[] = [];
    var flags: any = {};
    // Build the list of cities within the given district
    if (csvString) {
      const districtNameToSearch = districtName.toLowerCase();
      var locationsInState = await csv().fromString(csvString);
      cities = locationsInState
        .filter(
          (location: any) =>
            location.District.toLowerCase() === districtNameToSearch
        )
        .map((location: any) => location.City)
        .sort()
        .map((location: any, index: any) => {
          if (isValueSameAsLabel) {
            return { value: location, label: location };
          } else {
            return { value: index, label: location };
          }
        })
        .filter(function (entry) {
          if (flags[entry.label]) {
            return false;
          }
          flags[entry.label] = true;
          return true;
        });
    }
    return cities;
  }

  public static async getCityMapping(citiesLocationData: any) {
    let cities: any = [];
    for (let i = 0; i < citiesLocationData?.length; i++) {
      cities.push({
        value: citiesLocationData[i].resource.id,
        label: citiesLocationData[i].resource.name,
      });
    }
    return cities;
  }
  //can be used for future use and can be optimized
  //method to get unique districts from CSV file
  public static async getDistrictsFromCSV(csvString: string) {
    var districts: any = [];
    //Build the list of ditsricts
    if (csvString) {
      var locationsInState = await csv().fromString(csvString);
      districts = locationsInState
        .map(value => value.District.toLowerCase())
        .filter((value, index, array) => array.indexOf(value) === index);
      return districts;
    }
  }
}
